export const iconFontAwesomeFoodBeverageIceCream = (
	<i className="fa-solid fa-ice-cream"></i>
);
